import React, { useEffect, useState } from "react";
import "dayjs/locale/de";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers/TimePicker";
import { AccessTimeOutlined } from "@mui/icons-material";
import PropTypes from "prop-types";
import { textFieldDefaults } from "../formControlDefaults.js";

TimePicker.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function TimePicker(props) {
  const {
    item,
    value,
    onChange,
    error = null,
    showErrorText = false,
    disabled = false,
  } = props;
  const [localValue, setLocalValue] = useState(null);

  useEffect(() => {
    setLocalValue(dayjs(value));
  }, [value]);

  const convertToDefEventPara = (name, value) => {
    setLocalValue(value);
    if (value?.isValid())
      onChange({
        target: {
          name,
          value,
        },
      });
  };

  let helperText = "";
  if (showErrorText) helperText = error;

  let boolError = false;
  if (error) boolError = true;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
      <MuiTimePicker
        fullWidth
        label={item.label}
        name={item.name}
        value={localValue}
        onChange={(date) => convertToDefEventPara(item.name, date)}
        disabled={disabled}
        slots={{ openPickerIcon: AccessTimeOutlined }}
        slotProps={{
          textField: {
            ...textFieldDefaults,
            helperText: helperText,
            error: boolError,
          },
        }}
      />
    </LocalizationProvider>
  );
}
